import React from 'react';
import Link from 'next/link';
import { PATH_PRIVACY } from '@/constants/spa-routes';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/constants/colors';
import { ImagesPart } from '@/components/PagesSections/ZohoIntegration/SolveTickets/ImagesPart';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export default function BottomSection() {
  const isLgUp = useMediaQuery('(min-width: 1024px)');
  return (
    <div className="flex relative gap-3 items-center flex-col">
      <ImagesPart disableScroll={isLgUp} />
      <div className="flex w-full items-center flex-col md:gap-3.5 gap-4">
        <Typography
          $type="PSmall"
          $weight="500"
          className="font-jamjuree text-center opacity-30"
          $color={COLORS.WHITE}
        >
          CoSupport ® is a registered trademark in the US and other countries. All rights reserved.
          Unauthorized use is strictly prohibited.
        </Typography>
        <div className="privacy">
          <div className="flex md:gap-5 gap-5 flex-wrap items-center justify-center">
            <Link
              prefetch={false}
              href={PATH_PRIVACY.TERMS_OF_WEBSITE}
              className="underline !text-white h-fit underline-offset-1 opacity-30 hover:opacity-100 transition"
            >
              <Typography
                $type="PSmall"
                $color={COLORS.WHITE}
                $weight="500"
                className="font-jamjuree"
              >
                Terms of Website
              </Typography>
            </Link>
            <Link
              prefetch={false}
              href={PATH_PRIVACY.TERMS_OF_SERVICES}
              className="underline !text-white h-fit underline-offset-1 opacity-30 hover:opacity-100 transition"
            >
              <Typography
                $type="PSmall"
                $color={COLORS.WHITE}
                $weight="500"
                className="font-jamjuree"
              >
                Terms of Services
              </Typography>
            </Link>
            <Link
              prefetch={false}
              href={PATH_PRIVACY.ROOT}
              className="underline !text-white h-fit underline-offset-1 opacity-30 hover:opacity-100 transition"
            >
              <Typography
                $type="PSmall"
                $color={COLORS.WHITE}
                $weight="500"
                className="font-jamjuree"
              >
                Privacy and Cookies Policy
              </Typography>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
